import { all } from 'redux-saga/effects';
import vagasSaga from './vagas';
import appSagas from './app';

export default function* rootSaga() {
  yield all([appSagas(), vagasSaga()]);
}
